// *********************************************************
// FIXME !!! legacy script :: jQuery jTabs               ***
// *********************************************************

import { GetBreakpointWidth } from 'Utils/globals-bp';
import { searchbarFixedHeight } from 'Utils/ha-searcbar-functions';
import { updateUI } from 'SrcJS/script--updateUI';

/* Custome jQuery function 
 * jTabs
*/
(function (window, $, document, undefined) {
    /** jTabs **/
    var firstTabSwitch = true;
    $(function () {
        var tabContainers = $('div.mootabs_panel');

        tabContainers.hide().filter('.active').show();

        $('div#tabsinteractive ul li').click(function () {
            var $this = $(this);
            var title = $this.data("title");
            if (!title || title == "") {
                return;
            }

            var $activeTab = tabContainers.filter("#" + title);
            tabContainers.removeClass('active').hide();
            $activeTab.addClass('active').show();
            $('div#tabsinteractive ul li').removeClass('active');
            $(this).addClass('active');
            console.log();
            let selector_readmoreHeight = $activeTab.hasClass('mootabs_panel')
                ? '[data-readmore], .readmoreHeight'
                : '.mootabs_panel [data-readmore], .mootabs_panel .readmoreHeight';
            let tryToExpand = GetBreakpointWidth() >= 768;

            if (!firstTabSwitch && tryToExpand && $this.hasClass('active')) {
                // 2021-04-22 -- add 'new-way'
                // for active tab: try to expand text inside tab's content if there is ReadMore.js
                let $readmore = $activeTab.find(selector_readmoreHeight);
                $readmore.each(function () {
                    let $current = $(this);
                    let isExpanded = ($current.attr('aria-expanded') === 'true');
                    if (!isExpanded) {
                        $current.readmore('toggle');
                    }
                });

                // 2021-04-22 -- disable 'old-way'
                //if (!$readmore || $readmore.length < 1) {
                //    // for active tab: try to expand text inside tab's content if there is button 'show more/less'
                //    var $btnMore = $activeTab.find('.mere');
                //    if ($btnMore.length > 0) {
                //        var text = $btnMore.text();
                //        if (text == $btnMore.data('more') || text != $btnMore.data('less')) {
                //            $btnMore.trigger('click');
                //        }
                //        return;
                //    }
                //}
            }

            // FIX height (expandedHeight) of ReadMore.js inside hidden 'mootabs_panel' container
            setTimeout(function () {
                let $readmore = $activeTab.find(selector_readmoreHeight);
                $readmore.each(function () {
                    let $current = $(this);
                    //if ($current.css('max-height') == 'none') {
                    //    let maxHeight = $current.data('readmoreHeight--max-height') || '';
                    //    $current.css('max-height', maxHeight);
                    //}
                    $current.readmore('update');
                });
            }, 300);


            if (typeof (ga) != "undefined") {
                if ($(this).data("title") != "beskrivelse") {
                    ga('send', 'pageview', {
                        'page': window.location.pathname + '/' + $(this).data("title")
                    });
                }
            }

            //		if ($(this).data("title") == "beskrivelse") {
            //			history.pushState("", document.title, window.location.pathname + window.location.search);
            //		} else {
            //			window.location.hash = "tab-" + $(this).data("title");
            //		}
            if (!firstTabSwitch) {
                $('html, body').stop().animate({
                    scrollTop: tabContainers.closest(".kolonne1").offset().top - searchbarFixedHeight()
                }, 300);
            } else {
                firstTabSwitch = false;
            }
            //$('html, body').stop().animate({
            //    scrollTop: tabContainers.closest(".kolonne1").offset().top - searchbarFixedHeight()
            //}, 300);
            AppLoader.raf(function () {
                updateUI();
            }, 300 + 32);
            return false;
        }).filter('.active').click();
    });

})(global, jQuery, document);
